import { Alert, Box, Button, Text } from '@chakra-ui/react';
import TimezoneModal from './TimeZoneModal/timezone.modal';
import useNotificationBar from './useNotificationBar';

export default function NotificationBar() {
	const {
		handleCloseTimeZoneModalClick,
		handleOpenTimeZoneModalClick,
		handleStopImpersonatingClick,
		t,
		currentTimeZone,
		hasDifferentTimezone,
		impersonatedUser,
		isTimeZoneModalVisible,
		profileTimeZone,
	} = useNotificationBar();

	if (impersonatedUser) {
		return (
			<Alert status="info" display="flex" justifyContent="space-between">
				<Box fontWeight="500" display="flex">
					<Text mr={2}>{t('You are impersonating')} </Text> <Text fontWeight="600">{impersonatedUser.email}</Text>
				</Box>
				<Button size="xs" onClick={handleStopImpersonatingClick}>
					{t('Stop impersonating')}
				</Button>
			</Alert>
		);
	}

	if (hasDifferentTimezone) {
		return (
			<Box p="4" background="blue.100" display="flex" alignItems="center" flexDir={{ base: 'column', md: 'row' }}>
				<Text m="0">
					{t('Your current timezone "{{currentTimeZone}}" does not match your profile timezone "{{profileTimeZone}}"', {
						currentTimeZone,
						profileTimeZone,
					})}
				</Text>
				<Button
					color="blackAlpha.800"
					colorScheme="blackAlpha"
					fontWeight={500}
					variant="link"
					ml="auto"
					onClick={handleOpenTimeZoneModalClick}
				>
					{t('Read more')}
				</Button>
				<TimezoneModal close={handleCloseTimeZoneModalClick} isOpen={isTimeZoneModalVisible} />
			</Box>
		);
	}

	return null;
}
